import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export function useAuthRedirect() {
    const navigate = useNavigate();
    // Essa trava evita que o React Strict Mode rode a função duas vezes
    const hasRedirected = useRef(false);

    const handleRedirect = useCallback(() => {
        // Se já redirecionou nesta renderização, não faz nada
        if (hasRedirected.current) return;
        hasRedirected.current = true;

        const savedIntentStr = sessionStorage.getItem('conversion_intent');

        if (savedIntentStr) {
            try {
                const intent = JSON.parse(savedIntentStr);
                sessionStorage.removeItem('conversion_intent'); // Limpa imediatamente
                
                // Vai para a rota salva com os dados preenchidos
                navigate(intent.redirectTo, { 
                    state: { prefillData: intent.prefillData },
                    replace: true // Substitui o histórico para o botão 'Voltar' funcionar bem
                });
                return;
            } catch (e) {
                console.error("Failed to parse conversion intent", e);
            }
        }

        // Fallback padrão se não havia intenção salva
        navigate('/usuario', { replace: true });
    }, [navigate]);

    return { handleRedirect };
}